module.exports = __webpack_public_path__ + "static/media/logo-Carrier.2f5a67fa.png";